/**
 * 会员下拉框
 * 2019-08-02 chenxiaojian
 */
import React from 'react';
import { Select } from 'antd';


import http from '../../../axios/http';

class ClientSelect extends React.Component {

    state = {
        list: []
    }

    componentDidMount() {
        this.loadMeterInfo(this.props);
        if (this.props.onRef) {
            this.props.onRef(this)
        }
    }

    loadMeterInfo = (param) => {
        let url='/market/client/list';
        if(param.all===1){
            url=url+"?all=1";
        }
        http.get({
            url: url,
            success: (res) => {
                this.setState({ list: res});
            }
        });
    }

    onSelect = (key) => {
        let list = this.state.list;
        //key转为数字类型
        let keyInt = parseInt(key);
        if (list != null && list.length > 0) {
            for (let i = 0; i < list.length; i++) {
                if (list[i]["id"] === keyInt) {
                    this.props.onSelect(list[i]);
                }
            }
        }
    }

    render() {
        let onSelect = this.props.onSelect ? this.onSelect : null;
        return <Select {...this.props} onSelect={onSelect}
            showSearch={true}
            allowClear={this.props.allowClear === true}
            optionFilterProp="children"
        >
            {this.state.list.map(d =>
                <Select.Option
                    key={d["id"]}>
                    {d["name"] }
                </Select.Option>
            )}
        </Select>
    };
}

export default ClientSelect;